import { render, staticRenderFns } from "./farm_setting.vue?vue&type=template&id=c4032ff0&scoped=true&"
import script from "./farm_setting.vue?vue&type=script&lang=js&"
export * from "./farm_setting.vue?vue&type=script&lang=js&"
import style0 from "./farm_setting.vue?vue&type=style&index=0&id=c4032ff0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4032ff0",
  null
  
)

export default component.exports